import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=1505e719"
var script = {}
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=1505e719&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_epdqlcc3dmzbifjpwlzkpsihom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports